export default "__VITE_ASSET__C$vwQUKG__$_?component__"